import type { AddOnPurchaseProduct } from "../../activity/add-on-purchase/types";
import React, { useContext } from "react";
import MCartItem from "./MCartItem";
import { getRuleType, getRules } from "Utils/activityHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "Store";
export interface ProductRule {
  id: number;
  categoryName?: string;
  categoryType: string;
  categoryTypeValue: number;
  maxQuantity?: number;
  maxAmount?: number;
  minQuantity?: number;
  minAmount?: number;
  minItem?: number;
  maxItem?: number;
  activityId: number;
  type: string;
}
export interface ICartItem {
  id: number;
  sku: string;
  activityId: number;
  quantity: number;
  productRuleId: number;
  product: {
    sku: string;
    category: string;
    subCategory: string;
    finalPrice: string;
    purchaseType?: AddOnPurchaseProduct["purchaseType"];
    limitQty?: number | null;
    productName: string;
    productPic: string;
    productSize: string;
    description: string;
    listPrice: string;
    pdpViewable: boolean;
  };
}
export interface ProductGroupProps {
  tab: string;
  groupItem: {
    matchRule: boolean;
    productRule: ProductRule;
    cartItems: ICartItem[];
  };
  // define any other mehtods here
  [key: string]: any;
}

const MProductGroup: React.FC<ProductGroupProps> = (props) => {
  const { tab, groupItem, cartData, noTabData, isAddOnPurchase, ...rest } = props;
  const { loginState } = useContext(AppContext);
  const navigate = useNavigate()
  const location = useLocation()
  const { matchRule, productRule, cartItems } = groupItem;
  const { categoryName, categoryType } = productRule;
  const noItems =
    !noTabData && !cartItems?.length &&
    categoryType === "specify_category";
  const groups = cartData[tab].productGroup;
  return (
    <div className='groupWrapper'>
      {!isAddOnPurchase && (<div className="groupHead">
        <div className="title">{getRuleType(groupItem, groups)}</div>
        <div className="limitWrapper">
          <div className={matchRule ? "rules" : "rules highlight"}>
            {getRules(productRule, { tab }).map((rule, index) => {
              return (
                <span key={index} className="ruleItem">
                  {rule}
                </span>
              );
            })}
          </div>
        </div>
      </div>)}
      {!isAddOnPurchase && noItems && (
        <div
          className="btn-link"
          onClick={() => {
            const filter = {tab: tab, categories: [categoryName]}
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('filter', JSON.stringify(filter))
            const route = `/m/${props.activityId}?${searchParams.toString()}`
             navigate(route)
          }}
        >
          点击选择
        </div>
      )}
      <div className="cartItems">
        {cartItems?.map((item, index) => {
          return <MCartItem 
          loginState={loginState}
          key={item.id} cartItem={item} {...rest}></MCartItem>;
        })}
      </div>
    </div>
  );
};

export default MProductGroup;
